module.exports = __webpack_public_path__ + "static/media/choithramsMadhurS.af60272c.png";